import {paymentService} from "@/_services";

export default {
  getAllCards({dispatch, commit}) {
    dispatch("alert/clear", {}, { root: true });
    paymentService.getAllCards()
      .then(
        paymentMethods => {
          console.log(paymentMethods)
          commit("setPaymentMethodsData", paymentMethods);
        },
        error => {
          dispatch("alert/error", error, { root: true });
        }
      )
  },
  addCard({dispatch, commit}, {tokenId}) {
    dispatch("alert/clear", {}, { root: true });
    return paymentService.addCard(tokenId)
      .then(
        card => {
          dispatch("alert/success", "La tarjeta se guardo correctamente", {root: true})
          dispatch("getAllCards");
          return Promise.resolve(card.data[0]);
        },
        error => {
          dispatch("alert/error", error, {root: true})
          return Promise.reject();
        }
      )
  },
  updateCard({dispatch, commit}, {cardId, defaultStatus = true}) {
    dispatch("alert/clear", {}, { root: true });
    return paymentService.updateCard(cardId, defaultStatus)
      .then(
        (paymentMethods) => {
          dispatch("alert/success", "Has cambiado tu metodo de pago preferido con éxito", {root: true})
          commit("setPaymentMethodsData", paymentMethods);
          return Promise.resolve();
        },
        error => {
          dispatch("alert/error", error, {root: true})
          return Promise.reject();
        }
      )
  },
  deleteCard({dispatch, commit}, {cardId}) {
    dispatch("alert/clear", {}, { root: true });
    return paymentService.deleteCard(cardId)
      .then(
        () => {
          dispatch("alert/success", "Se eliminó tu tarjeta con éxito", {root: true})
          return Promise.resolve();
        },
        error => {
          dispatch("alert/error", error, {root: true})
          return Promise.reject();
        }
      )
  }
}
